import vue from "vue";
import {
  agreeOrg, getOrgPage, orgDetails, refuseOrg
} from "../../../services/attestation";

const state = {
  dataPages: [],
  total: 0,
  dataDetails: {},
  paginationInit: {current: 1, size: 10},
  detailVisible:false,
};

const getters = {
  dataPages: () => state.dataPages,
  total: () => state.total,
  paginationInit: () => state.paginationInit,
  dataDetails: () => state.dataDetails,
  detailVisible:()=>state.detailVisible,
};

const actions = {
  //分页
  getOrgPage({commit, dispatch}, objc) {
    getOrgPage(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data.records});
        commit('updateState', {state: 'total', update: res.data.total});
      } else {
        commit('updateState', {state: 'dataPages', update: []});
        commit('updateState', {state: 'total', update: 0});
      }
    })
  },
  //详情
  orgDetails({commit, dispatch}, objc) {
    orgDetails(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'dataDetails', update: res.data});
      }
    })
  },
  //同意
  agreeOrg({commit, dispatch}, objc) {
    agreeOrg(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getOrgPage', state.paginationInit);
        dispatch('orgDetails', objc);
      }
    })
  },
  //驳回
  refuseOrg({commit, dispatch}, objc) {
    refuseOrg(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getOrgPage', state.paginationInit);
        dispatch('orgDetails', objc);
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}





// WEBPACK FOOTER //
// ./src/store/attestation/modules/orgApproval.js